import React from 'react';
import { MobileSelect } from '../common';
import { AvailabilityWarning } from './AvailabilityWarning';

export default function ServiceCrewSelector({
  serviceIds,
  serviceOptions,
  serviceError,
  serviceSelectRef,
  onServicesChange,
  crewMemberId,
  crewMemberOptions,
  crewMemberError,
  crewMemberRef,
  onCrewChange,
  hasPaymentRestriction,
  availabilityConflict,
  selectedCrewMemberName,
  appointmentDate,
  appointmentTime,
  t,
}) {
  return (
    <>
      <div className="md:col-span-2" ref={serviceSelectRef}>
        <MobileSelect
          label="שירותים"
          value={serviceIds}
          onChange={onServicesChange}
          options={serviceOptions}
          placeholder="בחר שירותים"
          error={serviceError}
          required={true}
          disabled={hasPaymentRestriction}
          searchable={true}
          multiSelect={true}
        />
      </div>

      <div ref={crewMemberRef}>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t.crewMember} <span className="text-red-500">*</span>
        </label>

        {(!serviceIds || serviceIds.length === 0) && (
          <p className="text-sm text-amber-600 mb-2 bg-amber-50 p-2 rounded">
            {t.selectServiceToViewQualifiedMembers}
          </p>
        )}

        <div className="space-y-2">
          {crewMemberOptions.map(option => (
            <label
              key={option.value}
              className={`flex items-center p-3 border rounded-lg transition-colors ${option.disabled || hasPaymentRestriction
                ? 'bg-gray-50 border-gray-200 cursor-not-allowed opacity-60'
                : crewMemberId === option.value
                  ? 'bg-pink-50 border-pink-300 cursor-pointer'
                  : 'bg-white border-gray-200 hover:bg-gray-50 cursor-pointer'
                }`}
            >
              <input
                type="radio"
                name="crew_member_id"
                value={option.value}
                checked={crewMemberId === option.value}
                onChange={onCrewChange}
                disabled={option.disabled || hasPaymentRestriction}
                className="h-4 w-4 text-pink-600 focus:ring-pink-500 border-gray-300 ml-3"
              />
              <div className="ml-3 flex items-center justify-between w-full">
                <div className="flex items-center">
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium ml-3"
                    style={{ backgroundColor: option.color }}
                  >
                    {option.label.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2)}
                  </div>
                  <span className={`font-medium ${option.disabled ? 'text-gray-400' : 'text-gray-900'}`}>
                    {option.label}
                  </span>
                </div>
                {option.disabled && option.reason && (
                  <span className="text-xs text-gray-400 ml-2">
                    {option.reason}
                  </span>
                )}
              </div>
            </label>
          ))}
        </div>

        {crewMemberError && <p className="mt-1 text-sm text-red-600">{crewMemberError}</p>}
      </div>

      <div className="md:col-span-2">
        {availabilityConflict && (
          <AvailabilityWarning
            crewMemberName={selectedCrewMemberName || 'Selected crew member'}
            conflictInfo={availabilityConflict}
            appointmentDate={appointmentDate}
            appointmentTime={appointmentTime}
          />
        )}
      </div>
    </>
  );
}
